import { render, staticRenderFns } from "./UpdateMessage.vue?vue&type=template&id=29330c9f&scoped=true&"
import script from "./UpdateMessage.vue?vue&type=script&lang=js&"
export * from "./UpdateMessage.vue?vue&type=script&lang=js&"
import style0 from "./UpdateMessage.vue?vue&type=style&index=0&id=29330c9f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29330c9f",
  null
  
)

export default component.exports